import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { getCommonCodeLabel } from '../../../lib/store';

interface IProps {
  data: any;
}

const ClassLessonInfo: FC<IProps> = ({ data }) => {
  const { t, i18n } = useTranslation();
  return (
    <>
      <div className="text-left mt-4">
        <h5>{t('class.class.title3')}</h5>
      </div>
      <table className="table-custom">
        <colgroup>
          <col width="20%" />
          <col width="20%" />
          <col width="20%" />
          <col width="20%" />
          <col width="20%" />
        </colgroup>
        <tbody>
          <tr>
            <th className="text-center">{t('class.class.column21')}</th>
            <th className="text-center">{t('class.class.column22')}</th>
            <th className="text-center">{t('class.class.column23')}</th>
            <th className="text-center">{t('class.class.column24')}</th>
            <th className="text-center">{t('class.class.column25')}</th>
          </tr>
          {data?.classInfo?.map((item: any) => (
            <Fragment key={item.classWeekdayCode}>
              <tr>
                <td className="text-center" rowSpan={item.classTime.length}>
                  {getCommonCodeLabel('SY0001', item.lessonWeekday, i18n.language)}
                </td>
                <td className="text-center">
                  {item.classTime[0].classTimeSeq}
                </td>
                <td className="text-center">
                  {item.classTime[0].srtTime}
                </td>
                <td className="text-center">
                  {item.classTime[0].classRoomName}
                </td>
                <td className="text-center">
                  {item.classTime[0].teacherKorName}
                </td>
              </tr>
              {
                item.classTime.slice(1).map((subitem: any, subindex: number) => (
                  <tr key={subindex}>
                    <td className="text-center">
                      {subitem.classTimeSeq}
                    </td>
                    <td className="text-center">
                      {subitem.srtTime}
                    </td>
                    <td className="text-center">
                      {subitem.classRoomName}
                    </td>
                    <td className="text-center">
                      {subitem.teacherKorName}
                    </td>
                  </tr>
                ))
              }
            </Fragment>
          ))}
        </tbody>
      </table>
    </>
  );  
}

export default ClassLessonInfo;